import React from "react";
import ReactDOM from "react-dom";
import "./common.scss";
import "./index.scss";
import "./fonts/Montserrat/Montserrat.css";
import "./fonts/Inter/Inter.css";

import App from "./blocks/App/App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Routes from "./blocks/Routes/Routes";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="/routes">
            <Routes/>
          </Route>
          <Route path="*">
            <App />
          </Route>
        </Switch>        
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
